import { AUTH_ACTION_TYPES } from 'store/actions/auth.actions';
import { isCompletedAuth } from 'utils/auth';

/**
 * @type {import('src/store/types').AuthState}
 */
const initialState = {
  authInfo: undefined,
  accessToken: undefined,
  refreshToken: undefined,
  accessTokenExpire: undefined,
  mfaCodeResendTime: undefined,
  isAuthProcessed: false,
  isAuth: false,
  reLoginData: undefined,
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case AUTH_ACTION_TYPES.AUTH_LOGIN: {
      const nextState = { ...state, ...payload };

      return { ...nextState, isAuth: isCompletedAuth(nextState) };
    }

    case AUTH_ACTION_TYPES.AUTH_UPDATE_TOKENS: {
      const nextState = { ...state, ...payload };

      return { ...nextState, isAuth: isCompletedAuth(nextState) };
    }

    case AUTH_ACTION_TYPES.AUTH_UPDATE_AUTH_INFO: {
      const nextState = { ...state, authInfo: { ...payload } };

      return { ...nextState, isAuth: isCompletedAuth(nextState) };
    }

    case AUTH_ACTION_TYPES.AUTH_UPDATE_MFA_TIMER: {
      return { ...state, mfaCodeResendTime: payload.mfaCodeResendTime };
    }

    case AUTH_ACTION_TYPES.AUTH_CHANGE_PROCESSING: {
      return { ...state, isAuthProcessed: payload };
    }

    case AUTH_ACTION_TYPES.AUTH_LOGOUT: {
      const { authInfo } = state;
      const reLoginData =
        authInfo?.id && authInfo?.groups
          ? { id: authInfo.id, groups: authInfo.groups }
          : state.reLoginData;

      return {
        ...initialState,
        isAuth: isCompletedAuth(initialState),
        reLoginData,
      };
    }

    case AUTH_ACTION_TYPES.AUTH_CLEAR_RELOGIN_DATA: {
      return { ...state, reLoginData: undefined };
    }
    default: {
      return { ...state, isAuth: isCompletedAuth(state) };
    }
  }
}
